var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white font-size-14 text-26" },
    [
      _c(
        "div",
        { staticClass: "yxtbiz-enroll-manage__header-title font-bolder" },
        [_vm._v(_vm._s(_vm.$t("pc_biz_enroll_lbl_baseinfo" /* 基本信息 */)))]
      ),
      _c(
        "div",
        {
          staticClass:
            "yxtbiz-enroll-manage__header-content layout-flex p24 lh22",
        },
        [
          _c(
            "div",
            { staticClass: "flex-1 mr24" },
            [
              _c(
                "yxt-row",
                [
                  _c(
                    "yxt-col",
                    { staticClass: "pr24 layout-flex", attrs: { span: 12 } },
                    [
                      _c("span", { staticClass: "text-8c flex-shrink-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pc_biz_enroll_lbl_name" /* 报名名称 */)
                          ) + _vm._s(_vm.$t("pc_biz_enroll_lbl_colon" /* ： */))
                        ),
                      ]),
                      _c(
                        "yxt-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            "open-filter": true,
                            content: _vm.headerData.enrollName,
                            placement: "top",
                          },
                        },
                        [
                          _c("span", { staticClass: "nowrap ellipsis" }, [
                            _vm._v(_vm._s(_vm.headerData.enrollName)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("yxt-col", { staticClass: "pr24", attrs: { span: 12 } }, [
                    _c("span", { staticClass: "text-8c" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pc_biz_enroll_lbl_enrolled" /* 已报名 */)
                        ) + _vm._s(_vm.$t("pc_biz_enroll_lbl_colon" /* ： */))
                      ),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.headerData.registeredNum))]),
                  ]),
                ],
                1
              ),
              _c(
                "yxt-row",
                { staticClass: "mt12" },
                [
                  _c(
                    "yxt-col",
                    { staticClass: "pr24", attrs: { span: 12 } },
                    [
                      _c("span", { staticClass: "text-8c" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pc_biz_enroll_lbl_signupStatus" /* 报名状态 */
                            )
                          ) + _vm._s(_vm.$t("pc_biz_enroll_lbl_colon" /* ： */))
                        ),
                      ]),
                      _c(
                        "yxt-tag",
                        {
                          attrs: {
                            type: _vm.statusConfig[_vm.headerData.status].type,
                            size: "mini",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.statusConfig[_vm.headerData.status].text)
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("yxt-col", { staticClass: "pr24", attrs: { span: 12 } }, [
                    _c("span", { staticClass: "text-8c" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pc_biz_enroll_lbl_toaudit" /* 待审核 */)
                        ) + _vm._s(_vm.$t("pc_biz_enroll_lbl_colon" /* ： */))
                      ),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.headerData.waitCheckNum))]),
                  ]),
                ],
                1
              ),
              _c(
                "yxt-row",
                { staticClass: "mt12" },
                [
                  _c(
                    "yxt-col",
                    {
                      staticClass: "pr24 layout-flex over-hidden",
                      attrs: { span: 12 },
                    },
                    [
                      _c("span", { staticClass: "text-8c flex-shrink-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pc_biz_enroll_lbl_enrolltime" /* 报名时间 */
                            )
                          ) + _vm._s(_vm.$t("pc_biz_enroll_lbl_colon" /* ： */))
                        ),
                      ]),
                      _c(
                        "yxt-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            "open-filter": true,
                            content: _vm.enrollTime,
                            placement: "top",
                          },
                        },
                        [
                          _c("span", { staticClass: "nowrap ellipsis" }, [
                            _vm._v(_vm._s(_vm.enrollTime)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "yxt-col",
                    {
                      staticClass:
                        "pr24 layout-flex over-hidden layout-align-center",
                      attrs: { span: 12 },
                    },
                    [
                      _c("span", { staticClass: "text-8c flex-shrink-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pc_biz_enroll_lbl_signupUrl" /* 报名链接 */)
                          ) + _vm._s(_vm.$t("pc_biz_enroll_lbl_colon" /* ： */))
                        ),
                      ]),
                      _c(
                        "yxt-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            "open-filter": true,
                            content: _vm.qrCodeUrl,
                            placement: "top",
                          },
                        },
                        [
                          _c("span", { staticClass: "ellipsis mr8" }, [
                            _vm._v(_vm._s(_vm.qrCodeUrl)),
                          ]),
                        ]
                      ),
                      _c("yxt-svg", {
                        staticClass: "hand flex-shrink-0",
                        attrs: {
                          "icon-class": "o2o-enroll-copy",
                          width: "16px",
                          height: "16px",
                          "remote-url":
                            _vm.$staticBaseUrl + "ufd/55a3e0/o2o/pc/svg",
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.copyUrl.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "pr hand" }, [
            _vm.qrCodeUrl
              ? _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        _vm.qrCodeVisible = true
                      },
                    },
                  },
                  [
                    _c("yxtbiz-qrcode", {
                      attrs: {
                        size: 96,
                        url: _vm.qrCodeUrl,
                        "hide-link": true,
                        "hide-download": true,
                        padding: 0,
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "text-center mt8 font-size-12 lh20" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pc_biz_enroll_lbl_projectqrcode" /* 报名二维码 */
                            )
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
      _c(
        "yxt-dialog",
        {
          attrs: {
            "append-to-body": true,
            visible: _vm.qrCodeVisible,
            cutline: false,
            width: _vm.$isEnglish ? "480px" : "410px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrCodeVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c(
              "div",
              { staticClass: "mt8 mb12" },
              [
                _c("yxtbiz-qrcode", {
                  attrs: {
                    url: _vm.qrCodeUrl,
                    size: 218,
                    padding: 34,
                    "hide-link": false,
                    "hide-download": false,
                    name: _vm.headerData.enrollName,
                    "is-project": "",
                    "project-tip": _vm.projectTip,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }